<template>
    <div class="main">
        <router-link to="/purchase-order-menu" style="font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
            <p>
                <a-icon type="double-left" />
            </p> 
            <p>Go Back</p>
            
        </router-link >
        <div>
            <h3 style="font-size:28px;line-height:45px"> Generate P.O From Backorders </h3>
        </div>
        <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
            <a-button @click="showConfirmModal" :disabled="!hasSelected" :class="[ hasSelected ? 'activeBtn' : 'disbablesBtn' ]">
                Generate Purchase Orders
            </a-button>
            <!-- <a-button @click="exportExcell" style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                Export
            </a-button> -->
        </div>
        
        <div>
                <a-table
                :columns="columns"
                :data-source="tableBackOrdersProducts"
                :loading='tableLoading'
                :pagination="pagination"
                :row-selection="rowSelection"
                class="customerTable"
                >
                    <template slot="action" slot-scope="">    
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item >
                                    <a>Replenish Product?</a>
                                </a-menu-item>
                                
                            </a-menu>
                        </a-dropdown>
                    </template>

                    <template slot="status" slot-scope="data">
                        <status-component v-if="data" :status="data"></status-component>
                    </template>
                </a-table>
                <!-- Select Replenish  Filters -->
            <a-modal
            class="modalStyle"
            :visible="confirmVisible"
            width="800px"
            :footer="null"
            @cancel="handleConfirmCancel"
            >
                <a-spin :spinning="loading">
                    <!-- <p style="display:flex;justify-content: center;font-weight: bolder;align-items:center">
                        
                        
                    </p> -->
                    <div class="pt-4">
                        <h3 class="modalHeader pt-1 text-center">Kindly confirm all backorders with these product lines from  {{ startDate ? startDate : "N/A" }} to  {{ endDate ? endDate : "N/A" }}</h3>
                    </div>
                    <div class="pt-3">
                        <div>
                            <a-table
                                :columns="confirmColumns"
                                :data-source="tableConfirmedProducts"
                                :pagination="pagination"
                                class="customerTable"
                                >
                                
                                </a-table>
                        </div>
                        <div class="text-center">
                             <a-button @click="handleGeneratePO" :loading="loading" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Confirm
                            </a-button>
                        </div>
                       
                    </div>
                </a-spin>
            </a-modal>
          </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { NotificationMixins } from "@/mixins/NotificationMixins";

 
const confirmColumns = [
    {
        title: "Product ID",
        width: 90,
        dataIndex: 'productId',
        key: 'productId'
    },
    {
        title: 'Product Name',
        dataIndex: 'productBrandName',
        width: 100,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        width: 100,
    },
]

const columns = [
{
    title: "Product ID",
    width: 90,
    dataIndex: 'productId',
    key: 'productId'
  },
  {
    title: 'Product Name',
    dataIndex: 'productBrandName',
    width: 100,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    width: 100,
  },
  {
    title: 'Supplier Name',
    dataIndex: 'supplierName',
    width: 100,
  },
  {
    title: 'Purchase Price',
    dataIndex: 'purchasePrice',
    width: 100,
  },
  
  {
    title: 'Category Name',
    dataIndex: 'categoryName',
    width: 100,
  },
  {
    title: 'Total Sale Value',
    dataIndex: 'totalSaleValue',
    width: 100,
  },
  {
    title: 'Total Purchase Value',
    dataIndex: 'totalPurchaseValue',
    width: 100,
  },
//   {
//     title: 'Created At',
//     dataIndex: 'createdAt',
//     // width: 130,
//   },
 
//   {
//     title: 'Status',
//     dataIndex: 'status',
//     // width: 150,
//     scopedSlots: { customRender: 'status' }
//   },
 
//   {
//     title: 'Action',
//     dataIndex: 'action',
//     width: 100,
//     scopedSlots: { customRender: 'action' }
//   }
];


    export default {
        name: 'BackOrders',
        data(){
            return {
                columns,
                confirmColumns,
                tableBackOrdersProducts:[],
                tableConfirmedProducts: [],
                tableLoading: false,
                loading: false,
                confirmVisible:false,
                pagination: {
                    pageSize:5
                },
                startDate: null,
                endDate: null,
                status: "",
                selectedRowKeys: [],
                selectedRows: []
            }
        },
        mixins: [NotificationMixins],
        computed:{
            ...mapGetters(['getBackOrdersData']),
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
            
            rowSelection() {
                const { selectedRowKeys } = this;
                return {
                    selectedRowKeys,
                    onChange: this.onSelectChange,
                    hideDefaultSelections: true,
                    selections: [
                        {
                            key: 'all-data',
                            text: 'Select All Produts',
                            onSelect: () => {
                                this.selectedRowKeys = this.tableBackOrdersProducts.map(order => order.key); 
                                this.selectedRows = this.tableBackOrdersProducts   
                            },
                        },
                        {
                            key: 'unselect-data',
                            text: 'Deselect All Produts',
                            onSelect: () => {
                                this.selectedRowKeys = []; 
                                this.selectedRows = []
                            },
                        },
                    ],
                }
            },
            
        },
        methods:{
            ...mapActions(['setPreviewInfo']),
            onSelectChange(selectedRowKeys, selectedRows) {
                // console.log('selectedRowKeys changed: ', selectedRowKeys);
                // console.log('selectedRows changed: ', selectedRows);
                this.selectedRows = selectedRows
                this.selectedRowKeys = selectedRowKeys;
                
            },
            handleConfirmCancel(){
                this.confirmVisible = false
            },
            showConfirmModal(){
                if(this.status === 0 || this.status === 1 ){
                    this.confirmProduct()
                }else{
                    this.firmProduct()
                }
            },
            confirmProduct(){
                this.confirmVisible = true
                this.tableConfirmedProducts = this.selectedRows.map(order => ({
                    key: order.key,
                    productId: order.productId,
                    productBrandName: order.productBrandName,
                    quantity: order.quantity,
                    purchasePrice: order.purchasePrice
                }))
            },
            firmProduct(){
                const result = JSON.parse(this.getBackOrdersData)
            
                this.tableConfirmedProducts = this.selectedRows.map(order => ({
                    key: order.key,
                    productId: order.productId,
                    productBrandName: order.productBrandName,
                    quantity: order.quantity,
                    purchasePrice: order.purchasePrice
                }))
                const purchaseOrders = this.tableConfirmedProducts.map(order => ({
                    key: order.productId,
                    productId: order.productId,
                    name: order.productBrandName,
                    category: order.categoryName ? order.categoryName : "",
                    quantity: order.quantity.toString(),
                    unitPrice: order.purchasePrice.toString(),
                    lineTotal: parseInt(order.quantity) * parseFloat(order.purchasePrice)
                }))
                    
                let previewData = { 
                    discount: '',
                    deliveryDate: '',
                    supplierName: result.supplier.name,
                    supplierId: result.supplier.id,
                    supplierAddress: result.supplier.address,
                    supplierCity: '',
                    supplierCountry: '',
                    destionation: '',
                    sellerAddress: '',
                    shipCity: '',
                    shipCountry:'',
                    shippingMethod: '',
                    shippinTerm: '',
                    tableData: purchaseOrders,
                    statusLabel: '',
                    action:"add",
                    deleiveries:[]
                }
                // console.log("previewData | ", previewData)
                this.setPreviewInfo(JSON.stringify(previewData));  
                this.$router.push('/purchase-order-edit').catch(()=>{});
                this.loading = false;
                this.selectedRowKeys = [];
                this.selectedRows = []
                this.tableConfirmedProducts = []
            },

            async handleGeneratePO(){
                this.loading = true
                const result = JSON.parse(this.getBackOrdersData)
                const request = {
                    productIds: this.tableConfirmedProducts.map(order => order.productId),
                    startDate: result.startDate,
                    endDate: result.endDate,
                    status: this.status
                }
                // console.log("request | ", request)
                const response = await this.$store.dispatch("purchaseOrder/confirmProductLnes", request)
                if(response.status === 200){
                    const purchaseOrders = this.tableConfirmedProducts.map(order => ({
                        key: order.productId,
                        productId: order.productId,
                        name: order.productBrandName,
                        category: order.categoryName ? order.categoryName : "",
                        quantity: order.quantity.toString(),
                        unitPrice: order.purchasePrice.toString(),
                        lineTotal: parseInt(order.quantity) * parseFloat(order.purchasePrice)
                    }))
                    
                    let previewData = { 
                        discount: '',
                        deliveryDate: '',
                        supplierName: result.supplier.name,
                        supplierId: result.supplier.id,
                        supplierAddress: result.supplier.address,
                        supplierCity: '',
                        supplierCountry: '',
                        destionation: '',
                        sellerAddress: '',
                        shipCity: '',
                        shipCountry:'',
                        shippingMethod: '',
                        shippinTerm: '',
                        tableData: purchaseOrders,
                        statusLabel: '',
                        action:"add",
                        deleiveries:[]
                    }
                    // console.log("previewData | ", previewData)
                    this.setPreviewInfo(JSON.stringify(previewData));  
                    this.$router.push('/purchase-order-edit').catch(()=>{});
                    this.loading = false;
                    this.selectedRowKeys = [];
                    this.selectedRows = []
                    this.tableConfirmedProducts = []
                }else{
                    this.showErrorAlert(response.data.messages)
                }
            },
            loadBackOrdersData(){
                const result = JSON.parse(this.getBackOrdersData)
               
                this.startDate = moment(result.startDate).format("DD-MM-YYYY") 
                this.endDate = moment(result.endDate).format("DD-MM-YYYY") 
                this.status =  result.status
                this.tableBackOrdersProducts = result.backOrders.map(order => ({
                    key: order.productId,
                    productId: order.productId,
                    productBrandName: order.productBrandName,
                    quantity: order.quantity,
                    supplierName: order.supplierName,
                    purchasePrice: order.purchasePrice,
                    categoryName: order.categoryName,
                    totalSaleValue: order.totalSaleValue,
                    totalPurchaseValue: order.totalPurchaseValue
                }))
            }
            
        },
         created(){
            if(this.loadBackOrdersData){
                this.loadBackOrdersData()
            }
        }
    }
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.customerTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.disbablesBtn{
    color: rgba(0,0,0,.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    height:38px;
     border-raduis:5px; 
}
.activeBtn{
    height:38px;
    margin-right: 10px;
    border-raduis:5px; 
    background: #418a49; 
    color:#fff;
}
</style>